import { AbstractControl, FormControl, Validators, FormGroup, FormArray } from '@angular/forms';
import { Product } from './product.schema';
import { fileType } from '../helpers/validators/file-type.validator';

export class Collection {
    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            collectionName: new FormControl('', Validators.required),
            province: new FormControl('', Validators.required),
            collectionProducts: new FormArray([new FormGroup(CollectionProducts.validation())]),
            shopCollectionProductCategories: new FormControl([], Validators.required),
            bodyHtml: new FormControl(''),
            image: new FormControl(
                undefined,
                fileType(['png', 'jpg', 'gif', 'jpeg'])
            ),
        };
        return validator;
    }

    public static readonly validationMessages = {
        'collectionName': [{ type: 'required', message: 'Obbligatorio' }],
        'province': [{ type: 'required', message: 'Obbligatorio' }],
        'collectionProducts': {
            'product': {
                'id': [{ type: 'required', message: 'Obbligatorio' }]
            },
        },
        'shopCollectionProductCategories': [
            { type: 'required', message: 'Obbligatorio' }
        ],
    };

    public static collectionProductFormGroup() {
        return new FormGroup(CollectionProducts.validation());
    }

    constructor(
        public id?: number,
        public collectionName?: string,
        public province?: any,
        public collectionProducts?: any,
        public shopifyCollectionId?: string,
        public image?: string,
        public bodyHtml?: string,
        public handle?: string,
        public shopCollectionProductCategories?: any,
    ){ }
}

export class CollectionProducts {
    public static validation(): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            product: this.collectionProductFormGroup(),
        };
        return validator;
    }

    public static collectionProductFormGroup() {
        return new FormGroup({
            id: new FormControl('', Validators.required),
        });
    }

    constructor(
        public id?: number,
        public product?: Product,
    ) { }
}
